<template>
	<div id="list-meals">
		<h1>Refeiçoes</h1>
		<b-input-group prepend="Escolha o Menu" size="sm" class="mt-4" style="margin-bottom: 20px;">
    <b-form-select v-model="selected" :options="menuNames"></b-form-select>
		</b-input-group>
		<b-list-group v-if="selected !== null">
			<b-list-group-item
				class="d-flex justify-content-between align-items-center"
				v-for="(meal,index) in Meals"
				:key="index"
			>
				<b-container>
					<b-row>
						<b-col lg="8">{{meal.name}}</b-col>
						<b-col>
							<div class="mt-3">
								<b-button-group>
									<b-button variant="info" @click="flipViewFlags(index)">Ver</b-button>
									<b-button variant="info" @click="flipEditFlag(index,meal)">Alterar</b-button>
									<b-button variant="info" @click="$bvModal.show('my-modal-event'+meal.id)">Remover</b-button>
                  <b-modal :id="'my-modal-event'+meal.id" title="Apagar Refeiçao" @ok="deleteMeal(meal.id)">Apagar {{meal.name}} ?</b-modal>
								</b-button-group>
							</div>
						</b-col>
					</b-row>
					<b-row lg="10">
						<b-col>
							<div v-if="viewingFlags[index]">
                <form-meal editingMode="view" :meal="meal"></form-meal>
							</div>
							<div v-if="editingFlag - 1 == index">
                <form-meal editingMode="edit" :meal="meal"></form-meal>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
import api from "../../api";
import { jsonIn } from "../../utils/snakeCamel"
import formMeal from './formMeal'
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "listMeals",
  components:{formMeal},
	data() {
		return {
      selected: null,
      options: [],
			viewingFlags: [],
			editingFlag: 0
		};
	},
  computed:{
    ...mapGetters(['menusList','menuNames']),
    Meals: function (){
      return this.menusList.filter(menu => menu.title === this.selected)[0]['meals']
    }
  },
	methods: {
    ...mapActions(['refreshMenus']),
    deleteMeal(index){
      api.deleteMeal({id: index}).then(() =>
      this.refreshMenus()
      )
    },
		flipViewFlags: function(index) {
			if (index + 1 !== this.editingFlag) {
      this.$set(this.viewingFlags, index, !this.viewingFlags[index]);
      }
		},
		flipEditFlag: function(index, tour) {
			if (index + 1 !== this.editingFlag) {
				this.viewingFlags[index] = false;
				this.editingFlag = index + 1;
			} else {
				this.editingFlag = 0;
			}
		}
	}
};
</script>
<style script="css">
#list-meals {
	text-align: left;
}
</style>
